import * as React from "react";
import { Flex, Box } from "@chakra-ui/react";
import { Switch } from "components";
import { useCurrentCase } from "duck";
import { Create } from "./components";
import { useUpdateAdditionalTest } from "./duck";

const AdditionalTests: React.FC = () => {
  const additionalTests = useCurrentCase(
    ({ data }) => data.client.patient.diagnosticTesting.additionalTests
  );

  const onChange = useUpdateAdditionalTest();

  return (
    <>
      <Flex wrap="wrap" columnGap={16} rowGap={6}>
        {additionalTests.map(test => (
          <Box key={test.test}>
            <Switch
              isChecked={test.toPerform}
              label={test.test}
              onChange={() => {
                onChange({ ...test, toPerform: !test.toPerform });
              }}
            />
          </Box>
        ))}
      </Flex>
      <Create exclude={additionalTests} />
    </>
  );
};

export default AdditionalTests;
